
  import { Component } from 'vue-property-decorator'
  import { GPdf } from '@/components/dataTables/PDF/GPdf'
  import jsPDF from 'jspdf'
  import { LinkedCellOptions } from '@/components/dataTables/cell/index'
  import { mapGetters } from 'vuex'
  import { Stock } from '@/entities/sales/Stock'
  import { fixPrice } from '@/utils/general'
  import axios from 'axios'
  import { Car } from '@/entities/public'
  import { plainToInstance } from 'class-transformer'

@Component({
  computed: {
    ...mapGetters('app', ['system']),
  },
  methods: {
    fixPrice,
  },
})
  export default class StockQrCodeCell extends GPdf {
  declare options: LinkedCellOptions
  declare item: Stock
  loading = false;
  carPhoto = ''
  stock: Stock
  car: Car = plainToInstance(Car, {})
  partsToDisplay: string[] = []

  system!: string

  async mounted () {
    const { item: { id } } = this
    if (!id) return

    this.stock = await this.fetchData({
      query: { name: 'fetch', model: 'Stock', params: { id } },
      force: true,
    })

    this.car = (await this.fetchData({
      query: { name: 'find', model: 'Car' },
      filter: { auto: { id: { _eq: this.stock.auto.id } } },
      force: true,
    }))[0]
  }

  async docHandler (partsToDisplay: string[]) {
    this.loading = true

    this.partsToDisplay = partsToDisplay
    this.stock.viewDetails.auto.version = await this.fetchData({
      query: { name: 'fetch', model: 'VersionYear', params: { id: this.stock.viewDetails.auto.version.id } },
    })
    await this.getDocData()

    this.loading = false
  }

  async generatePDF (fileName) {
    const JsPDF = jsPDF
    const doc = new JsPDF('p', 'mm', 'a2')

    await doc.html(this.$refs.pdfContent)
    doc.save(fileName)
    this.loading = false
  }

  async getDocData () {
    const { partsToDisplay } = this

    await this.getSystem()

    if (partsToDisplay.includes('details')) {
      await this.getCarData()
    }

    if (partsToDisplay.includes('qr')) {
      await this.getPost()
    }
  }

  async getPost () {
    const url = `${process.env.VUE_APP_WEB_URL}${this.car?.id}`
    const qrUrl = `${process.env.VUE_APP_BASE_URL}/convert-pdf-to-image/generate-qr`

    const response = await axios.post(qrUrl, { url }, { responseType: 'arraybuffer' })
    const base64 = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    )

    const responseUrl = `data:image/png;base64,${base64}`

    this.$set(this.docData, 'post', {
      url,
      qr: responseUrl,
    })
  }

  async getCarData () {
    const { stock, partsToDisplay } = this
    const { auto } = stock

    const equipmentLimit = partsToDisplay.includes('qr') ? 15 : 29

    let securityEquipment = stock.viewDetails.auto.version.attributes
      .filter(item => item.slug === 'security_equipment')
      .map(item => item.val)
    if (securityEquipment.length > equipmentLimit) {
      securityEquipment = securityEquipment.slice(0, equipmentLimit)
      securityEquipment.push('Más...')
    }

    let basicEquipment = stock.viewDetails.auto.version.attributes
      .filter(item => item.slug === 'basic_equipment')
      .map(item => item.val)
    if (securityEquipment.length > equipmentLimit) {
      basicEquipment = basicEquipment.slice(0, equipmentLimit)
      basicEquipment.push('Más...')
    }

    this.$set(this.docData, 'car', {
      brand: auto.version.version.model.brand.name,
      model: auto.version.version.model.name,
      version: auto.version.version.name,
      year: auto.version.year.id,
      licensePlate: auto.registrationPlate,
      mileage: Number(stock.viewDetails.attributes.find(item => item.slug === 'mileage')?.val),
      ownersNumber: Number(stock.viewDetails.attributes.find(item => item.slug === 'owners_number')?.val),
      color: stock.viewDetails.attributes.find(item => item.slug === 'color')?.val,
      traction: stock.viewDetails.auto.version.attributes.find(item => item.slug === 'traction')?.val,
      transmission: stock.viewDetails.auto.version.attributes.find(item => item.slug === 'transmission')?.val,
      fuel: stock.viewDetails.auto.version.attributes.find(item => item.slug === 'fuel')?.val,
      displacement: stock.viewDetails.auto.version.attributes.find(item => item.slug === 'cylender')?.val,
      price: stock.priceAmount,
      securityEquipment,
      basicEquipment,
    })
  }

  get disableQr () {
    const { car } = this

    return !car?.id
  }

  get fileName () {
    const { docData: { car }, partsToDisplay } = this

    const prefixParts = []
    if (partsToDisplay.includes('details')) {
      prefixParts.push('Cartel')
    }
    if (partsToDisplay.includes('qr')) {
      prefixParts.push('QR')
    }

    const prefix = prefixParts.join('-')
    const carName = `${car.brand} ${car.model} ${car.year} ${car.licensePlate}`
    return `${prefix} ${carName}.pdf`
  }

  get action () {
    return this.options?.action
  }

  get iconColor () {
    const { options } = this

    return options?.action?.iconColor || 'white'
  }

  get disabledButton () {
    const { item } = this

    return !item?.id || !item?.prices?.length
  }
  }
